module.exports = __webpack_public_path__ + "static/img/3.001c2d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/eng/3.png
// module id = BYcH
// module chunks = 0